import { g as isFunction } from "../../vendor-2b2dbafd.mjs";
const resolveSlot = (slot) => {
  return slot && isFunction(slot) ? slot() : slot;
};
export {
  resolveSlot as r
};
//# sourceMappingURL=resolveSlot-3ed82fa4.mjs.map
